// Map WorkSetupModal string values to the backend worksetup codes.
export const mapWorkSetup = (str) =>
  str === 'WFH' ? 2 : str === 'Deployed' ? 3 : 1;
